/*
 * @Author: hucaili hucaili@qfei.cn
 * @Date: 2023-05-31 09:30:17
 * @LastEditors: hucaili hucaili@qfei.cn
 * @LastEditTime: 2023-05-31 11:49:55
 * @FilePath: /fe-crm/src/store/modules/calendar.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import { defineStore } from 'pinia';

export const useCalendarStore = defineStore('calendar', {
  state: () => {
    return { calendarData: '' };
  },
  actions: {
    updateCalendarState(data) {
      //存储数据
      this.calendarData = data;
    },
    clearCalendarState() {
      //清空数据
      this.calendarData = '';
    }
  }
});
export default useCalendarStore;
